import { useIsAuthenticated, useMsal } from '@azure/msal-react';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Badge, Button, Modal } from 'react-bootstrap';
import { connect } from 'react-redux';
import { setAnonymousUser } from '../stores/appAction';

const LoginGate = ({ component: WrappedComponent, setAnonymousUserInStore, anonymousUser }) => {
  const isAuthenticated = useIsAuthenticated();
  const { instance } = useMsal();
  const [showLoginModal, setShowLoginModal] = useState(false);

  useEffect(() => {
    if (isAuthenticated || anonymousUser) {
      setShowLoginModal(false);
    } else {
      setShowLoginModal(true);
    }
  }, [isAuthenticated, anonymousUser]);

  const handleWithoutLogin = () => {
    setShowLoginModal(false);
    setAnonymousUserInStore();
  };

  const handleWithLogin = () => {
    setShowLoginModal(false);
    instance.loginRedirect();
  };
  return (
    <>
      {showLoginModal ? (
        <Modal show centered style={{ display: 'block' }}>
          <Modal.Header>
            <Modal.Title className="h5">Bạn có muốn lưu lại kết quả trắc nghiệm?</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <p><b>Lưu ý:</b></p>
            <p>
              <i>- Chọn vào</i>
              {' '}
              <Badge variant="primary">Tiếp tục</Badge>
              {' '}
              <i>
                để đăng nhập và kết quả của bạn sẽ được lưu lại sau khi hoàn thành bài trắc nghiệm
              </i>
            </p>
            <p>
              <i>- Chọn </i>
              <Badge variant="danger">Không cần</Badge>
              <i> nếu không muốn lưu lại kết quả.</i>
            </p>
          </Modal.Body>
          <Modal.Footer>
            <Button variant="danger" onClick={handleWithoutLogin}>
              Không cần
            </Button>
            <Button variant="primary" onClick={handleWithLogin}>
              Tiếp tục
            </Button>
          </Modal.Footer>
        </Modal>
      ) : <WrappedComponent />}
    </>
  );
};

const mapStateToProps = state => ({
  anonymousUser: state.app.anonymousUser
});

const mapDispatchToProps = dispatch => ({
  setAnonymousUserInStore: () => dispatch(setAnonymousUser())
});

LoginGate.propTypes = {
  component: PropTypes.elementType.isRequired,
  setAnonymousUserInStore: PropTypes.func.isRequired,
  anonymousUser: PropTypes.bool.isRequired
};

export default connect(mapStateToProps, mapDispatchToProps)(LoginGate);
